<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16.488 4.488A1.667 1.667 0 0015.31 4H5.667C4.747 4 4 4.746 4 5.667v9.643c0 .442.176.866.488 1.178l11.083 11.084c.651.65 1.707.65 2.357 0l9.643-9.643a1.666 1.666 0 000-2.357L16.489 4.488zM6 15.172V6h9.172l10.75 10.75-9.172 9.172L6 15.172z" clip-rule="evenodd"/><path d="M11.333 9.667a1.667 1.667 0 11-3.333 0 1.667 1.667 0 013.333 0z"/></svg>
</template>

<script>
export default {
  name: 'shopTagOutline'
}
</script>
